module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.b06871f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/fa/fontawesome-webfont.ttf
// module id = 694
// module chunks = 1